module.exports = __webpack_public_path__ + "img/PriceQuotationAffiliateOperations.b61c7908.svg";